import { Message } from "../../../types/types";

export function removeIFCMessages(arr: Array<Message>) {
  return arr.filter((obj) => !/interest free credit/gim.test(obj.title));
}
